module.exports = __webpack_public_path__ + "src/assets/img/phone-title1.65c7a256.png";